import {trans} from '@frontend/helpers'
import {useItemsSearchLocationSelectedHandler} from '@frontend/modules/public/ads/components/search/hooks/useItemsSearchLocationSelectedHandler'
import {useAdsStore} from '@frontend/stores'
import {mdiChevronDown} from '@mdi/js'
import {iconLocation} from '@shared/helpers/icons'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {Modal} from 'swayok-react-mdb-ui-kit/components/Modal/Modal'
import {useModalControls} from 'swayok-react-mdb-ui-kit/helpers/modals/useModalControls'
import {LocationSelectorModalContent} from './LocationSelectorModalContent'

interface LocationSelectorProps {
    iconMode?: boolean
    textMode?: boolean
}

// Компонент для выбора локации для поиска объявлений в ней.
export function LocationSelector(props: LocationSelectorProps) {

    const {
        iconMode,
        textMode,
    } = props

    const location = useAdsStore(
        state => state.searchPanelLocation
    )

    const onLocationChange = useItemsSearchLocationSelectedHandler()

    // Управление состоянием видимости модального окна.
    const {
        openModal,
        closeModal,
        modalProps,
    } = useModalControls()

    return (
        <div className="offered-items-filter-location">
            {textMode && (
                <Button
                    color="link"
                    className="link-dark with-icon-flex gap-2 p-0"
                    onClick={openModal}
                >
                    {location?.name ?? trans().common.ads_filter.any_location}
                    <Icon path={iconLocation} />
                </Button>
            )}
            {!textMode && iconMode && (
                <IconButton
                    path={iconLocation}
                    className="offered-items-filter-locations-icon"
                    onClick={openModal}
                />
            )}
            {!textMode && !iconMode && (
                <Button
                    color="gray"
                    outline
                    className="btn-offered-items-filter-location-selector d-flex flex-row align-items-center justify-content-start"
                    onClick={openModal}
                >
                    {/* Макет: слева от названия локации стоит маркер. */}
                    <Icon
                        path={iconLocation}
                        className="offered-items-filter-button-icon"
                    />
                    <span className="flex-1">
                        {location?.name ?? trans().common.ads_filter.any_location}
                    </span>
                    <Icon
                        path={mdiChevronDown}
                        className="offered-items-filter-button-chevron"
                    />
                </Button>
            )}

            <Modal
                {...modalProps}
                size="lg"
                scrollable
                staticBackdrop
                closeOnEsc
                centered={false}
                dialogId="offered-items-filter-location-picker"
                render={
                    <LocationSelectorModalContent
                        onClose={closeModal}
                        onLocationChange={onLocationChange}
                        currentLocation={location ?? null}
                    />
                }
            />
        </div>
    )
}
